import DeliverToSection from 'components/OrderConfirmation/SddSections/DeliverToSection/DeliverToSection';
import withDeliverToSectionProps from 'viewModel/orderConfirmation/sddSections/withDeliverToSectionProps';

const ConnectedDeliverToSection = withDeliverToSectionProps(DeliverToSection);

export default ConnectedDeliverToSection;
